import React from 'react';
import {twMerge} from 'tailwind-merge';

import {ErrorIcon} from '../../Icons';
import {MaxWidthContainer} from '../../Layout';

const AlertResponsive = (props) => {
    const {description, className} = props;

    return (
        <MaxWidthContainer
            className={twMerge(
                'my-4 flex flex-col gap-3 rounded bg-secondary p-4 md:flex-row md:gap-2 md:px-5',
                className
            )}
        >
            {<ErrorIcon className='h-6 w-6 shrink-0' />}
            <p
                className='font-bold'
                dangerouslySetInnerHTML={{
                    __html: description,
                }}
            />
        </MaxWidthContainer>
    );
};

export default AlertResponsive;
